"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
var _customPage = require("@/api/customPage");
var _diamondWithType_DetailPop = _interopRequireDefault(require("./diamondWithType_DetailPop.vue"));
var _bannerListPop = _interopRequireDefault(require("../../components/bannerListPop.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    diamondWithType_DetailPop: _diamondWithType_DetailPop.default,
    bannerListPop: _bannerListPop.default
  },
  data: function data() {
    return {
      componentCode: '',
      componentSubcode: '',
      id: '',
      dialogVisible: false,
      title: '',
      status: '',
      name: '',
      options: [{
        label: '启用',
        value: 1
      }, {
        label: '停用 ',
        value: 0
      }],
      tableData: []
    };
  },
  methods: {
    bannerBuff: function bannerBuff(val) {
      this.$refs.bannerListPop.open({
        name: this.name,
        id: this.id,
        componentSubcode: this.componentSubcode,
        componentCode: this.componentCode,
        categoryId: val.categoryId
      });
    },
    needRefresh: function needRefresh() {
      // 通知组件刷新（单个组件）
      this.findList();
      this.$emit('refresh', this.id);
    },
    del: function del(val) {
      var _this = this;
      console.log(val);
      this.$confirm('确认删除类目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deleteDiamondCategory)({
          categoryId: val.categoryId
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this.findList();
          //   this.$emit('refresh', this.id)
        });
      });
    },
    onClose: function onClose() {
      this.title = '';
      this.status = '';
      this.tableData = [];
      this.dialogVisible = false;
    },
    add: function add() {
      this.$refs.diamondWithType_DetailPop.open({
        moduleId: this.id,
        type: 'add'
      });
    },
    detail: function detail(val) {
      this.$refs.diamondWithType_DetailPop.open((0, _objectSpread2.default)({
        moduleId: this.id
      }, val));
    },
    open: function open(data) {
      console.log(data);
      this.id = data.id;
      this.componentCode = data.componentCode;
      this.componentSubcode = data.componentSubcode;
      this.name = data.name;
      this.findList();
      this.dialogVisible = true;
    },
    findList: function findList() {
      var _this2 = this;
      (0, _customPage.getDiamondCategoryList)({
        moduleId: this.id,
        bannerName: this.title,
        status: this.status
      }).then(function (res) {
        _this2.tableData = res.data;
      });
    },
    clear: function clear() {
      this.title = '';
      this.status = '';
      this.findList();
    },
    search: function search() {
      this.findList();
    }
  }
};